export enum ResponsiveBreakPoints {
  BigDesktop = 1920,
  Desktop = 1600,
  DesktopMedium = 1440,
  DesktopMin = 1320, // 1080 + 240 (width of left nav)
  Notebook = 1268,
  Tablet = 1024,
  Mobile = 768,
  SmallMobile = 375,
  ExtraSmallMobile = 320,
}

// NEW shippoTheme
// xs: 0,
// // 501 covers 99% of mobile devices and Chrome at its smallest width
// sm: 501,
// // Tablet
// md: 768,
// // Landscape tablet and netbooks
// lg: 1024,
// // Laptop
// xl: 1440,

export const MAX_CONTENT_WIDTH = '1040px';
